import { Collection } from 'modules/core/lib/mobx-rest'

import ShiftTemplate from 'modules/shift_management/store/api/models/ShiftTemplate'

class ShiftTemplates extends Collection<ShiftTemplate> {
  get cacheKey(): string {
    return 'shiftTemplates'
  }

  model() {
    return ShiftTemplate
  }

  get withTemplateWeeks(): ShiftTemplate[] {
    return this.filter((s) => s.weeks.length > 0)
  }

  get active(): ShiftTemplate[] {
    return this.filter((t) => t.isActive)
  }
}

const singleton: ShiftTemplates = new ShiftTemplates()

export default singleton
